











import {Component, Prop, Vue} from "vue-property-decorator";
import {Card} from "@/types/landing/Card";

@Component
export default class CompanyCard extends Vue {
  @Prop({type: Object, default: () => ({imgSrc: null, title: null, description: null})}) readonly card!: Card;
  @Prop({type: Number, default: 0}) readonly index!: number;

  get sm(): number {
    if (this.index === 0) {
      return 9;
    } else if (this.index === 1) {
      return 7;
    } else {
      return 7;
    }
  }
}
